<template>
  <div class="form-group">
    <label v-html="question.statement"></label>

    <select
      v-if="!question.allowsMultipleChoice"
      class="form-control"
      @change="onChange"
      :value="getAnswerValueForSelect()"
      :disabled="disabledAttribute"
    >
      <option v-for="o in question.options">{{ o }}</option>
    </select>

    <div class="row" v-if="question.allowsMultipleChoice">
      <div class="col-xs-12" v-for="o in question.options">
        <label class="checkbox-inline">
          <input type="checkbox" v-bind:value="o" v-model="m_answer.value" :disabled="disabledAttribute">
          <span v-html="o"></span>
        </label>
      </div>
    </div>

    <p class="text-red" v-if="m_error">{{ m_error }}</p>
  </div>
</template>

<script>
  export default {
    props: ['question', 'answer', 'isDisabled'],
    name: 'MultipleChoiceQuestion',
    data () {
      return {
        m_question: this.question,
        m_answer: {
          questionUuid: this.question.uuid,
          value: (this.answer && this.answer.value !== null) ? this.answer.value : []
        },
        m_error: null
      }
    },
    watch: {
      'm_answer.value' () {
        this.$emit('answerUpdated', this.m_answer)
      }
    },
    computed: {
      disabledAttribute () {
        return this.question.disabled === true || this.isDisabled === true
      }
    },
    methods: {
      getAnswerValueForSelect () {
        return this.m_answer.value ? this.m_answer.value[0] : null
      },
      onChange (data) {
        this.m_answer.value = [data.target.value]
      },
      isValid () {
        if (this.question.required && !this.m_answer.value.length) {
          this.m_error = 'Esta questão é de preenchimento obrigatório.'
          return false
        }
        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MultipleChoiceQuestion.vue?56ea05d5